import Logo from "../images/logo.svg";
import GhLogo from "../images/gh-logo.png";
import LILogo from "../images/linkedin-logo.svg";
const Footer = () => {

  return (
    <div className="footer">
      <img className="footer-logo" src={Logo} alt="Casey Alvarez logo"/>
      <div className="mt-4 py-5">
        <h2>software engineer</h2>
        <div className="footer-info">
          <span><a href="mailto:casey@caseyalvarez.com">casey@caseyalvarez.com</a>&nbsp;&nbsp;|&nbsp;&nbsp;philadelphia, pa</span>
          <div className="social-logos">
            <a href="https://github.com/CaseyAlvarez" target="_blank" rel="noopener noreferrer" aria-label="GitHub profile">
              <img src={GhLogo} alt="GitHub"/>
            </a>
            <a href="https://www.linkedin.com/in/casey-alvarez-28a92123/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn profile">
              <img src={LILogo} alt="LinkedIn"/>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer;
